/**
 * widgets/registry.tasks.tsx — Task Manager widgety (2.1).
 * Uživatelské / systémové / modulové úlohy odděleně + běhy + události.
 */
import {
  Activity,
  CalendarClock,
  FolderKanban,
  History,
  Lock,
  Package,
  User,
} from 'lucide-react';
import type { WidgetSpec } from './types';
import {
  EventsPanel,
  ModuleTasksPanel,
  ProjectTasksPanel,
  RunsPanel,
  SystemTasksPanel,
  UserTasksPanel,
} from '../pages/modules/tasks/panels';

export const TASKS_WIDGETS: WidgetSpec[] = [
  {
    id: 'tasks.user',
    title: 'Moje úlohy',
    module: 'tasks',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: User,
    since: '2.1.0',
    component: UserTasksPanel,
  },
  {
    id: 'tasks.system',
    title: 'Systémové úlohy',
    module: 'tasks',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Lock,
    since: '2.1.0',
    component: SystemTasksPanel,
  },
  {
    id: 'tasks.modules',
    title: 'Modulové úlohy',
    module: 'tasks',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Package,
    since: '2.1.0',
    component: ModuleTasksPanel,
  },
  {
    id: 'tasks.projects',
    title: 'Projektové úlohy',
    module: 'tasks',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: FolderKanban,
    since: '2.1.0',
    component: ProjectTasksPanel,
  },
  {
    id: 'tasks.runs',
    title: 'Běhy úloh',
    module: 'tasks',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: History,
    since: '2.1.0',
    component: RunsPanel,
  },
  {
    id: 'tasks.events',
    title: 'Události',
    module: 'tasks',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Activity,
    since: '2.1.0',
    component: EventsPanel,
  },
  // Legacy compact list (My Panel / dashboard glance) — remains in registry.tsx
];

// Re-export icons used by catalog if needed
export const TASKS_ICONS = {
  CalendarClock,
  User,
  Lock,
  Package,
  FolderKanban,
  History,
  Activity,
};
